"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.testHospital = exports.associations = exports.yale = exports.amc = exports.partners = exports.mgpo = exports.brigham = exports.mgh = exports.CODAMETRIX = void 0;
exports.CODAMETRIX = {
    children: [],
    id: 1,
    version: 0,
    createdDate: 1562168858387,
    updateDate: null,
    organizationName: "CodaMetrix",
    organizationCode: "CMX",
    displayName: null,
    shortDisplayName: null,
    customerName: "CodaMetrix",
    tenantId: "BB4D9AA3-3047-4542-8FB1-8C9BD6E4D75C",
    organizationType: "BUSINESS",
    address1: null,
    address2: null,
    city: "Boston",
    state: "MA",
    zipCode: null,
    phone: null,
    contactName: null,
    parentTenantId: null,
    parentLevel: 0,
    requireDedicatedSiteHeader: null,
    dedicatedSiteHeader: null,
    timeZoneFullName: "America/Los_Angeles",
    awsCognitoIndicator: false,
    ssoIndicator: false,
    active: true
};
exports.mgh = {
    id: 5,
    version: 1,
    createdDate: 1565962761909,
    updateDate: null,
    organizationName: "Massachusetts General Hospital",
    displayName: null,
    shortDisplayName: null,
    organizationCode: "MGH",
    customerName: "Massachusetts General Hospital",
    tenantId: "C89EA023-2426-4517-9F23-D308925DD65D",
    organizationType: "HOSPITAL",
    address1: null,
    address2: null,
    city: null,
    state: null,
    zipCode: null,
    phone: null,
    contactName: null,
    parentTenantId: "BE8D65EB-C6AF-45F2-900A-A186ABB5FD59",
    parentLevel: 2,
    requireDedicatedSiteHeader: null,
    dedicatedSiteHeader: null,
    parentId: 2,
    defaultRelationship: null,
    serviceLines: [],
    timeZoneFullName: "America/Los_Angeles",
    awsCognitoIndicator: false,
    ssoIndicator: false,
    active: true,
    children: [
        {
            id: 17,
            version: 1,
            createdDate: 1565962761971,
            updateDate: null,
            organizationName: "Mass General Physicians Organization",
            displayName: null,
            shortDisplayName: null,
            organizationCode: "MGPO",
            customerName: "Mass General Physicians Organization",
            tenantId: "7FFCD78E-8CF8-42C4-B1F3-9335D7D3135B",
            organizationType: "PHYSICIAN_ORGANIZATION",
            address1: null,
            address2: null,
            city: null,
            state: null,
            zipCode: null,
            phone: null,
            contactName: null,
            parentTenantId: "BE8D65EB-C6AF-45F2-900A-A186ABB5FD59",
            parentLevel: 2,
            requireDedicatedSiteHeader: null,
            dedicatedSiteHeader: null,
            parentId: 2,
            defaultRelationship: null,
            serviceLines: [],
            children: [],
            relatedOrganizations: [],
            timeZoneFullName: "America/Los_Angeles",
            awsCognitoIndicator: false,
            ssoIndicator: false,
            active: true
        }
    ],
    relatedOrganizations: [
        {
            id: 17,
            version: 1,
            createdDate: 1565962761971,
            updateDate: null,
            organizationName: "Mass General Physicians Organization",
            organizationCode: "MGPO",
            customerName: "Mass General Physicians Organization",
            tenantId: "7FFCD78E-8CF8-42C4-B1F3-9335D7D3135B",
            organizationType: "PHYSICIAN_ORGANIZATION",
            address1: null,
            address2: null,
            city: null,
            state: null,
            zipCode: null,
            phone: null,
            contactName: null,
            parentTenantId: "BE8D65EB-C6AF-45F2-900A-A186ABB5FD59",
            parentLevel: 2,
            requireDedicatedSiteHeader: null,
            dedicatedSiteHeader: null,
            parentId: 2,
            defaultRelationship: null,
            serviceLines: [],
            children: [],
            relatedOrganizations: [],
            active: true
        }
    ]
};
exports.brigham = {
    id: 12,
    version: 1,
    createdDate: 1591037094563,
    updateDate: null,
    organizationName: "Brigham & Women's Hospital",
    organizationCode: "BWH",
    tenantId: "ABCCCEEA-6193-4575-B90D-C7E657C0B922",
    organizationType: "HOSPITAL",
    customerName: "Brigham & Women's Hospital",
    address1: null,
    address2: null,
    city: null,
    state: null,
    zipCode: null,
    phone: null,
    contactName: null,
    displayName: null,
    shortDisplayName: null,
    parentTenantId: "BE8D65EB-C6AF-45F2-900A-A186ABB5FD59",
    parentLevel: 2,
    requireDedicatedSiteHeader: null,
    dedicatedSiteHeader: null,
    parentId: 2,
    defaultRelationship: null,
    serviceLines: [],
    children: [],
    relatedOrganizations: [],
    timeZoneFullName: "America/Los_Angeles",
    awsCognitoIndicator: false,
    ssoIndicator: false,
    active: true
};
exports.mgpo = {
    id: 17,
    version: 1,
    createdDate: 1565962761971,
    updateDate: null,
    organizationName: "Mass General Physicians Organization",
    organizationCode: "MGPO",
    displayName: null,
    shortDisplayName: null,
    customerName: "Mass General Physicians Organization",
    tenantId: "7FFCD78E-8CF8-42C4-B1F3-9335D7D3135B",
    organizationType: "PHYSICIAN_ORGANIZATION",
    address1: null,
    address2: null,
    city: null,
    state: null,
    zipCode: null,
    phone: null,
    contactName: null,
    parentTenantId: "BE8D65EB-C6AF-45F2-900A-A186ABB5FD59",
    parentLevel: 2,
    requireDedicatedSiteHeader: null,
    dedicatedSiteHeader: null,
    parentId: 2,
    defaultRelationship: null,
    serviceLines: [],
    children: [],
    relatedOrganizations: [],
    timeZoneFullName: "America/Los_Angeles",
    awsCognitoIndicator: false,
    ssoIndicator: false,
    active: true
};
exports.partners = {
    id: 2,
    version: 1,
    createdDate: 1565962761897,
    updateDate: null,
    organizationName: "Partners Health System",
    displayName: null,
    shortDisplayName: null,
    organizationCode: "PHS",
    customerName: "Partners Health System",
    tenantId: "BE8D65EB-C6AF-45F2-900A-A186ABB5FD59",
    organizationType: "HEALTH_SYSTEM",
    address1: null,
    address2: null,
    city: null,
    state: null,
    zipCode: null,
    phone: null,
    contactName: null,
    parentTenantId: "BB4D9AA3-3047-4542-8FB1-8C9BD6E4D75C",
    parentLevel: 1,
    requireDedicatedSiteHeader: null,
    dedicatedSiteHeader: null,
    parentId: 1,
    defaultRelationship: null,
    serviceLines: [],
    children: [exports.brigham, exports.mgpo, exports.mgh],
    relatedOrganizations: [],
    timeZoneFullName: "America/Los_Angeles",
    awsCognitoIndicator: false,
    ssoIndicator: false,
    active: true
};
exports.amc = {
    id: 74,
    version: 6,
    createdDate: 1614010486290,
    updateDate: null,
    organizationName: "AMC Health System",
    displayName: "AMC Health System",
    shortDisplayName: "AMCHS",
    organizationCode: "AMCHS",
    customerName: "AMC Health System",
    tenantId: "",
    organizationType: "HEALTH_SYSTEM",
    address1: null,
    address2: null,
    city: null,
    state: null,
    zipCode: null,
    phone: null,
    contactName: null,
    parentTenantId: "BB4D9AA3-3047-4542-8FB1-8C9BD6E4D75C",
    parentLevel: 1,
    requireDedicatedSiteHeader: null,
    dedicatedSiteHeader: null,
    parentId: 1,
    defaultRelationship: null,
    serviceLines: [],
    children: [],
    relatedOrganizations: [],
    timeZoneFullName: "America/Los_Angeles",
    awsCognitoIndicator: false,
    ssoIndicator: false,
    active: true
};
exports.yale = {
    id: 78,
    version: 3,
    createdDate: 1623945910649,
    updateDate: null,
    organizationName: "Yale New Haven Health",
    displayName: "Yale New Haven Health",
    shortDisplayName: null,
    organizationCode: "YNHH",
    customerName: "Yale",
    tenantId: "",
    organizationType: "HEALTH_SYSTEM",
    address1: null,
    address2: null,
    city: null,
    state: null,
    zipCode: null,
    phone: null,
    contactName: null,
    parentTenantId: "BB4D9AA3-3047-4542-8FB1-8C9BD6E4D75C",
    parentLevel: 1,
    requireDedicatedSiteHeader: null,
    dedicatedSiteHeader: null,
    parentId: 1,
    defaultRelationship: null,
    serviceLines: [],
    children: [],
    relatedOrganizations: [],
    timeZoneFullName: "America/New_York",
    awsCognitoIndicator: false,
    ssoIndicator: false,
    active: true
};
exports.associations = [
    {
        id: 17,
        version: 1,
        createdDate: 1563827325928,
        updateDate: null,
        organizationName: "Mass General Physicians Organization",
        organizationCode: "MGPO",
        displayName: null,
        shortDisplayName: null,
        customerName: "Mass General Physicians Organization",
        tenantId: "7FFCD78E-8CF8-42C4-B1F3-9335D7D3135B",
        organizationType: "HOSPITAL",
        address1: null,
        address2: null,
        city: null,
        state: null,
        zipCode: null,
        phone: null,
        contactName: null,
        parentTenantId: "BE8D65EB-C6AF-45F2-900A-A186ABB5FD59",
        parentLevel: 2,
        requireDedicatedSiteHeader: null,
        dedicatedSiteHeader: null,
        children: [],
        relatedFromOrganizations: [],
        relatedToOrganizations: [],
        timeZoneFullName: "America/Los_Angeles",
        awsCognitoIndicator: false,
        ssoIndicator: false,
        active: true
    }
];
exports.testHospital = {
    id: 77,
    version: 0,
    createdDate: 1621531826678,
    updateDate: null,
    organizationName: "Test Hospital",
    organizationCode: "TH",
    displayName: null,
    shortDisplayName: null,
    customerName: "Test Hospital",
    tenantId: "",
    organizationType: "HOSPITAL",
    address1: null,
    address2: null,
    city: null,
    state: null,
    zipCode: null,
    phone: null,
    contactName: null,
    parentTenantId: "BE8D65EB-C6AF-45F2-900A-A186ABB5FD59",
    parentLevel: 2,
    requireDedicatedSiteHeader: null,
    dedicatedSiteHeader: null,
    parentId: 2,
    defaultRelationship: null,
    serviceLines: [],
    children: [],
    relatedOrganizations: [],
    timeZoneFullName: "",
    awsCognitoIndicator: false,
    ssoIndicator: false,
    active: true
};
//# sourceMappingURL=orgs.js.map